import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ScheduleReportAdminComponent } from './schedule-report-admin.component';
import {
    IconsModule,
    LayoutModule,
    TableModule,
    TableSearchModule,
} from '@monsido/angular-shared-components';

import { FormsModule } from '@angular/forms';
import { OrderByModule } from '@monsido/ng2/shared/pipes/order-by/order-by.module';
import { ReportCenterPipesModule } from '@monsido/modules/report-center/pipes/report-center-pipes.module';
import { SharedModule } from '@monsido/ng2/shared/shared.module';
import { TranslateModule } from '@client/app/modules/translate.module';
import { MonAvatarComponent } from '@client/app/shared/mon-avatar/mon-avatar.component';
import { NgbTooltipMfeModule } from '@client/mfe/overlay/ngb-tooltip-mfe.module';

@NgModule({
    declarations: [
        ScheduleReportAdminComponent,
    ],
    exports: [ScheduleReportAdminComponent],
    imports: [
        CommonModule,
        SharedModule,
        OrderByModule,
        LayoutModule,
        TranslateModule,
        NgbTooltipMfeModule,
        FormsModule,
        IconsModule,
        ReportCenterPipesModule,
        TableModule,
        TableSearchModule,
        MonAvatarComponent,
    ],
})
export class ScheduleReportAdminModule {}
